import './StaffLayout.css'

import { NavLink, Outlet, useNavigate } from 'react-router'
import { useAtomValue, useSetAtom } from 'jotai'

import { staff } from '../store'

import { BrandLogo } from '../components/BrandLogo'
import { useRequireStaff } from '../hooks/useRequireStaff'

const staffHome = '/staff/dashboard'

export function StaffLayout() {
  useRequireStaff()

  const session = useAtomValue(staff.staffSessionAtom)
  const authStatus = useAtomValue(staff.staffSessionStatusAtom)
  const logout = useSetAtom(staff.staffLogoutAtom)
  const navigate = useNavigate()

  const handleLogout = async () => {
    await logout()
    navigate('/staff/login', { replace: true })
  }

  if (authStatus !== 'authenticated') {
    return (
      <div className="staff-layout staff-layout--loading">
        <p className="staff-layout__loading-text">Loading staff session…</p>
      </div>
    )
  }

  const staffName = session?.staff.name || session?.staff.email || 'Staff'
  const roleName = session?.staff.roleName

  return (
    <div className="staff-layout">
      <aside className="staff-layout__sidebar">
        <div className="staff-layout__sidebar-top">
          <div className="staff-layout__branding">
            <BrandLogo to={staffHome} layout="full" size="md" onChrome />
            <p className="staff-layout__tagline">Staff console</p>
          </div>

          <nav className="staff-layout__nav" aria-label="Staff">
            <NavLink
              to="/staff/dashboard"
              className={({ isActive }) =>
                `staff-layout__nav-link${isActive ? ' staff-layout__nav-link--active' : ''}`
              }
            >
              Dashboard
            </NavLink>
            <NavLink
              to="/staff/moderation"
              className={({ isActive }) =>
                `staff-layout__nav-link${isActive ? ' staff-layout__nav-link--active' : ''}`
              }
            >
              Moderation
            </NavLink>
            <NavLink
              to="/staff/settings"
              className={({ isActive }) =>
                `staff-layout__nav-link${isActive ? ' staff-layout__nav-link--active' : ''}`
              }
            >
              Settings
            </NavLink>
          </nav>
        </div>

        <footer className="staff-layout__sidebar-footer">
          <div className="staff-layout__staff-meta">
            <span className="staff-layout__staff-name">{staffName}</span>
            {roleName && <span className="staff-layout__staff-role">{roleName}</span>}
          </div>
          <button type="button" className="staff-layout__sign-out" onClick={handleLogout}>
            Sign out
          </button>
        </footer>
      </aside>

      <div className="staff-layout__body">
        <header className="staff-layout__header">
          <BrandLogo to={staffHome} layout="full" size="sm" className="staff-layout__mobile-logo" />
          <div className="staff-layout__header-meta">
            <span className="staff-layout__header-name">{staffName}</span>
            <button type="button" className="staff-layout__header-sign-out" onClick={handleLogout}>
              Sign out
            </button>
          </div>
        </header>

        <main className="staff-layout__main">
          <Outlet />
        </main>

        <nav className="staff-layout__bottom-nav" aria-label="Staff mobile">
          <NavLink
            to="/staff/dashboard"
            className={({ isActive }) =>
              `staff-layout__bottom-nav-link${isActive ? ' staff-layout__bottom-nav-link--active' : ''}`
            }
          >
            Dashboard
          </NavLink>
          <NavLink
            to="/staff/moderation"
            className={({ isActive }) =>
              `staff-layout__bottom-nav-link${isActive ? ' staff-layout__bottom-nav-link--active' : ''}`
            }
          >
            Moderation
          </NavLink>
          <NavLink
            to="/staff/settings"
            className={({ isActive }) =>
              `staff-layout__bottom-nav-link${isActive ? ' staff-layout__bottom-nav-link--active' : ''}`
            }
          >
            Settings
          </NavLink>
        </nav>
      </div>
    </div>
  )
}
